import React from "react";
import { useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import PropTypes from "prop-types";
import { webappURL } from "../../util/url";
import SellerTabs from "./SellerTabs";
import SellerList from "./SellerList";
import SellerCollectionHeader from "./SellerCollectionHeader";
import SellerCollectionContent from "./SellerCollectionContent";
import SellerCollectionOpenGraph from "./SellerCollectionOpenGraph";
import SellerCollectionTwitterCard from "./SellerCollectionTwitterCard";
import useSellerCollectionData from "./hooks/useSellerCollectionData";
import "./SellerCollection.css";

/**
 * 셀러 컬렉션 페이지
 */
const SellerCollection = ({ hostname }) => {
  const { sellerCollectionId: encodedSellerCollectionId } = useParams();
  const initialTabId = encodedSellerCollectionId
    ? parseInt(encodedSellerCollectionId, 36)
    : null;
  const location = useLocation();

  const {
    collectionsData,
    collectionData,
    collectionLoading,
    activeTab,
    metaTitle,
  } = useSellerCollectionData(initialTabId);

  return (
    <section className="Seller-collection-container container">
      <Helmet>
        <title>{metaTitle}</title>
        {collectionData && collectionData.description && (
          <meta name="description" content={collectionData.description} />
        )}
        <link rel="canonical" href={webappURL(hostname) + location.pathname}/>
      </Helmet>
      <SellerCollectionOpenGraph
        collection={collectionData}
        url={`${webappURL(hostname)}${location.pathname}`}
        title={metaTitle}
      />
      <SellerCollectionTwitterCard
        collection={collectionData}
        title={metaTitle}
      />

      <SellerTabs
        collections={collectionsData && collectionsData.getGuideCollections}
        activeTab={activeTab}
      />

      <div className="seller-collection-container">
        <SellerCollectionHeader
          collection={collectionData}
          loading={collectionLoading}
        />
        <SellerCollectionContent collection={collectionData} />
      </div>

      {activeTab && <SellerList guideCollectionId={activeTab} limit={20} />}
    </section>
  );
};

SellerCollection.propTypes = {
  hostname: PropTypes.string,
};

export default SellerCollection;
